import styled from 'styled-components';

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;

  label.lfc-product-quantity-label {
    margin-top: 0;
  }
  
  @media (min-width: 1024px) {
    margin-right: 15px;
  }
`;
